import React from 'react';
import Konva from 'konva';
import { Group, Text as KonvaText } from 'react-konva';
import { setProjectState } from '@starflow/app/store';

Konva._fixTextRendering = true;

export const Text = React.memo(({ element, editingElementId }) => {
  const { data } = element;
  const isEditing = editingElementId === element.id;

  const handleEditText = () => {
    setProjectState({ editingElementId: element.id });
  };

  return (
    <Group>
      <KonvaText
        role="element"
        roleType="text"
        id={`${element.id}-text`}
        onDblClick={handleEditText}
        name={element.id}
        listening={!isEditing}
        fill={data.color}
        lineHeight={1}
        {...data}
        fontFamily={`${data.fontFamily}, Arial`}
      />
    </Group>
  );
});
